import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["overlay", "panel", "form"];
  static values = { indexUrl: String };

  open() {
    this.overlayTarget.classList.remove("hidden");
    document.body.classList.add("overflow-hidden");
  }

  dismiss() {
    // Close without applying changes
    this.overlayTarget.classList.add("hidden");
    document.body.classList.remove("overflow-hidden");
  }

  apply() {
    // Apply filters and navigate to index
    if (this.hasFormTarget) {
      const formData = new FormData(this.formTarget);
      const params = new URLSearchParams();

      // Handle array params correctly
      for (const [key, value] of formData.entries()) {
        if (value) {
          params.append(key, value);
        }
      }

      this.overlayTarget.classList.add("hidden");
      document.body.classList.remove("overflow-hidden");

      // Navigate to index URL (not the count URL)
      const baseUrl = this.indexUrlValue;
      const url = params.toString()
        ? `${baseUrl}?${params.toString()}`
        : baseUrl;

      window.Turbo.visit(url, { action: "replace" });
    }
  }

  clear() {
    if (this.hasFormTarget) {
      // Uncheck all checkboxes
      const checkboxes = this.formTarget.querySelectorAll(
        'input[type="checkbox"]',
      );
      checkboxes.forEach((checkbox) => (checkbox.checked = false));

      // Trigger form submit to update count
      this.formTarget.requestSubmit();

      // Get query param only
      const formData = new FormData(this.formTarget);
      const query = formData.get("query") || "";

      this.overlayTarget.classList.add("hidden");
      document.body.classList.remove("overflow-hidden");

      const baseUrl = this.indexUrlValue;
      const url = query
        ? `${baseUrl}?query=${encodeURIComponent(query)}`
        : baseUrl;

      window.Turbo.visit(url, { action: "replace" });
    }
  }
}
